export default from './results-page';



// WEBPACK FOOTER //
// ./app/containers/results-page/index.js